import { WorkPackageDescriptionGeneratedEntity } from "./generated/WorkPackageDescriptionGeneratedEntity";

export abstract class WorkPackageDescriptionEntity extends WorkPackageDescriptionGeneratedEntity {
    // Comment to preserve new line
}
